import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormFeedback,
} from "reactstrap";
import classnames from "classnames";

import { useFormik } from "formik";
import * as Yup from "yup";
import ReactQuill from "react-quill";
import { useNavigate, useParams } from "react-router-dom";
import BlogService from "../../../services/KangarooServices/BlogService";
import toast from "react-hot-toast";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import MediaService from "../../../services/KangarooServices/MediaServices";
import MediaModal from "../../PagesSection/Component/MediaModal";
import { imageBaseApi } from "../../../utilis/imageHelper";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import TestService from "../../../services/KangarooServices/TestService";

const TestCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("1");
  const [initialData, setInitialData] = useState(null);
  const [mediaData, setMediaData] = useState([]);
  const [mediaModalState, setMediaModalState] = useState({
    isOpen: false,
    targetField: "",
    index: null,
  });
  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  // Fetch test detail
  const fetchDetail = async () => {
    try {
      if (!id) return;
      const response = await TestService.getDetail(id);
      setInitialData(response);
    } catch (error) {
      console.log(error);
    }
  };
  console.log("Test", initialData);
  // Fetch media list
  const fetchMedia = async () => {
    try {
      const response = await MediaService.getList({ page: 1, pageSize: 1000 });
      setMediaData(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDetail();
    fetchMedia();
  }, [id]);

  // Compute initialValues for Formik
  const initialValues = useMemo(() => {
    if (!initialData) {
      return {
        testHeading: "",
        preparationName: "",
        description: "",
        testStrctureDesc: "",
        logoMediaId: "",
        logoMedia: null,
        bannerMedia: null,
        bannerMediaId: "",
        isActive: true,
        testStructures: [
          {
            id: "",
            name: "",
            description: "",
            orderIndex: 0,
            mediaId: "",
            media: null,
            isActive: true,
          },
        ],
        testProperties: [
          {
            id: "",
            name: "",
            description: "",
            orderIndex: 0,
            mediaId: "",
            media: null,
            shouldShowBeforeTestStructures: false,
          },
        ],
      };
    }

    return {
      testHeading: initialData.testHeading || "",
      preparationName: initialData.preparationName || "",
      description: initialData.description || "",
      bannerMedia: initialData.media || null,
      logoMedia: initialData.logoMedia || null,
      testStrctureDesc: initialData?.testStrctureDesc || "",
      bannerMediaId: initialData.bannerMediaId || "",
      isActive: initialData.isActive ?? true,
      testStructures: initialData.testStructures?.length
        ? initialData.testStructures.map((ts) => ({
            id: ts.id || "",
            name: ts.name || "",
            description: ts.description || "",
            orderIndex: ts.orderIndex ?? 0,
            mediaId: ts.mediaId || "",
            isActive: ts.isActive ?? true,
            media: ts.media || null,
          }))
        : [
            {
              id: "",
              name: "",
              description: "",
              orderIndex: 0,
              mediaId: "",
              media: null,
              isActive: true,
            },
          ],

      testProperties: initialData.testProperties?.length
        ? initialData.testProperties.map((ts) => ({
            id: ts.id || "",
            name: ts.name || "",
            description: ts.description || "",
            orderIndex: ts.orderIndex ?? 0,
            mediaId: ts.mediaId || "",
            shouldShowBeforeTestStructures:
              ts.shouldShowBeforeTestStructures ?? true,
            media: ts.media || null,
          }))
        : [
            {
              id: "",
              name: "",
              description: "",
              orderIndex: 0,
              mediaId: "",
              media: null,
              shouldShowBeforeTestStructures: false,
            },
          ],
    };
  }, [initialData]);

  console.log("🚀 ~ TestCreate ~ initialValues:", initialValues);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,

    onSubmit: async (values) => {
      try {
        const payload = {
          testHeading: values.testHeading,
          preparationName: values.preparationName,
          description: values.description,
          bannerMediaId: values.bannerMediaId || null,
          logoMediaId: values.logoMediaId || null,
          testStrctureDesc: values.testStrctureDesc,
          isActive: values.isActive ?? true,
          testStructures: values.testStructures.map((ts) => ({
            id: ts.id || null,
            isActive: ts.isActive ?? true,
            name: ts.name,
            description: ts.description,
            orderIndex: ts.orderIndex ?? 0,
            mediaId: ts.mediaId || null,
          })),
          testProperties: values.testProperties.map((ts) => ({
            id: ts.id || null,
            shouldShowBeforeTestStructures:
              ts.shouldShowBeforeTestStructures ?? true,
            name: ts.name,
            description: ts.description,
            orderIndex: ts.orderIndex ?? 0,
            mediaId: ts.mediaId || null,
          })),
        };

        if (id) {
          await TestService.update(id, payload);
          toast.success("Test Preparation Updated successful");
        } else {
          await TestService.create(payload);
          toast.success("Test Preparation Created successful");
        }

        navigate("/test-preparation");
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong");
      }
    },
  });
  console.log("🚀 ~ TestCreate ~ formik values:", formik.values);
  // useEffect(() => {
  //   if (initialData?.testStructures?.length) {
  //     formik.setFieldValue(
  //       "testStructures",
  //       initialData.testStructures.map((ts) => ({
  //         id: ts.id || "",
  //         name: ts.name || "",
  //         description: ts.description || "",
  //         mediaId: ts.mediaId || "",
  //         isActive: ts.isActive ?? true,
  //         media: ts.media || null,
  //       }))
  //     );
  //   }
  // }, [initialData]);

  // Media modal handlers
  const toggleMediaModal = (targetField = "", index = null) => {
    setMediaModalState({
      isOpen: !mediaModalState.isOpen,
      targetField,
      index,
    });
  };

  const handleMediaSelect = (media) => {
    console.log("🚀 ~ handleMediaSelect ~ media:", media);
    const { targetField, index } = mediaModalState;

    if (targetField === "banner") {
      formik.setFieldValue("bannerMediaId", media.id);
      formik.setFieldValue("bannerMedia", media);
    }
    if (targetField === "logo") {
      formik.setFieldValue("logoMediaId", media.id);
      formik.setFieldValue("logoMedia", media);
    }
    if (targetField === "testStructure" && index !== null) {
      const updated = [...formik.values.testStructures];
      updated[index].mediaId = media.id;
      updated[index].media = media;
      formik.setFieldValue("testStructures", updated);
    }
    if (targetField === "testProperties" && index !== null) {
      const updated = [...formik.values.testProperties];
      updated[index].mediaId = media.id;
      updated[index].media = media;
      formik.setFieldValue("testProperties", updated);
    }
    setMediaModalState({ isOpen: false, targetField: "", index: null });
  };

  // TestStructures helpers
  const addTestStructure = () => {
    formik.setFieldValue("testStructures", [
      ...formik.values.testStructures,
      {
        id: "",
        name: "",
        description: "",
        orderIndex: 0,
        mediaId: "",
        media: null,
        isActive: true,
      },
    ]);
  };

  const removeTestStructure = (index) => {
    const updated = formik.values.testStructures.filter((_, i) => i !== index);
    formik.setFieldValue("testStructures", updated);
  };

  const updateTestStructure = (index, field, value) => {
    // const updated = [...formik.values.testStructures];
    // updated[index][field] = value;
    // formik.setFieldValue("testStructures", updated);
    formik.setFieldValue(
      "testStructures",
      formik.values.testStructures.map((ts, i) =>
        i === index ? { ...ts, [field]: value } : ts
      )
    );
  };
  // test properties

  // TestStructures helpers
  const addTestProperties = () => {
    formik.setFieldValue("testProperties", [
      ...formik.values.testProperties,
      {
        id: "",
        name: "",
        description: "",
        orderIndex: 0,
        mediaId: "",
        media: null,
        shouldShowBeforeTestStructures: false,
      },
    ]);
  };

  const removeTestProperties = (index) => {
    const updated = formik.values.testProperties.filter((_, i) => i !== index);
    formik.setFieldValue("testProperties", updated);
  };

  const updateTestProperties = (index, field, value) => {
    formik.setFieldValue(
      "testProperties",
      formik.values.testProperties.map((ts, i) =>
        i === index ? { ...ts, [field]: value } : ts
      )
    );
  };
  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb
          title="Test Preparation Form"
          pageTitle="Test Preparation"
          breadcrumbItems={[
            { testHeading: "Back to List", link: "/test-preparation" },
          ]}
        />

        <div className="d-flex justify-content-end mb-3 gap-3">
          <Button color="success" onClick={formik.handleSubmit}>
            {id ? "Update" : "Create"}
          </Button>
          <Button color="danger" onClick={() => navigate("/test-preparation")}>
            Cancel
          </Button>
        </div>
        <Row>
          <Col lg={8}>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "1" })}
                  onClick={() => toggleTab("1")}
                >
                  General Info
                </NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => toggleTab("2")}
                >
                  Banner Media
                </NavLink>
              </NavItem> */}
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => toggleTab("2")}
                >
                  Test Structures
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "3" })}
                  onClick={() => toggleTab("3")}
                >
                  Test Properties
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab} className="mt-3">
              {/* General Info */}
              <TabPane tabId="1">
                <Card>
                  <CardBody>
                    <FormGroup>
                      <Label>Test Heading</Label>
                      <Input
                        name="testHeading"
                        value={formik.values.testHeading}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.testHeading &&
                          !!formik.errors.testHeading
                        }
                      />
                      {formik.touched.testHeading &&
                        formik.errors.testHeading && (
                          <FormFeedback>
                            {formik.errors.testHeading}
                          </FormFeedback>
                        )}
                    </FormGroup>

                    <FormGroup>
                      <Label>Preparation Name</Label>
                      <Input
                        name="preparationName"
                        value={formik.values.preparationName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.preparationName &&
                          !!formik.errors.preparationName
                        }
                      />
                      {formik.touched.preparationName &&
                        formik.errors.preparationName && (
                          <FormFeedback>
                            {formik.errors.preparationName}
                          </FormFeedback>
                        )}
                    </FormGroup>

                    <FormGroup>
                      <Label>Description</Label>
                      <ReactQuill
                        theme="snow"
                        value={formik.values.description}
                        onChange={(value) =>
                          formik.setFieldValue("description", value)
                        }
                        onBlur={() =>
                          formik.setFieldTouched("description", true)
                        }
                      />
                      {formik.touched.description &&
                        formik.errors.description && (
                          <div
                            className="text-danger mt-1"
                            style={{ fontSize: "0.875em" }}
                          >
                            {formik.errors.description}
                          </div>
                        )}
                    </FormGroup>
                  </CardBody>
                </Card>
              </TabPane>

              {/* Banner Media */}
              {/* <TabPane tabId="2">
                <Card>
                  <CardBody>
                    <div className="d-flex justify-content-between align-items-center">
                      <Label style={{ cursor: "pointer" }}>Banner Media</Label>
                      <Button
                        size="sm"
                        color="success"
                        onClick={() => toggleMediaModal("banner")}
                      >
                        +
                      </Button>
                    </div>

                    {selectedMedia ? (
                      <div className="mt-2 text-center">
                        <img
                          src={`${imageBaseApi}${selectedMedia.url}`}
                          alt={selectedMedia.fileName}
                          style={{
                            maxHeight: "200px",
                            maxWidth: "100%",
                            borderRadius: "6px",
                          }}
                        />
                      </div>
                    ) : (
                      <p className="text-muted mt-2">No media selected</p>
                    )}
                  </CardBody>
                </Card>
              </TabPane> */}

              {/* Test Structures */}
              <TabPane tabId="2">
                <Card>
                  <CardBody>
                    <FormGroup>
                      <Label>Test Structure Description</Label>
                      <Input
                        name="testStrctureDesc"
                        value={formik.values.testStrctureDesc}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.testStrctureDesc &&
                          !!formik.errors.testStrctureDesc
                        }
                        type="textarea"
                        rows={3}
                      />

                      {formik.touched.testStrctureDesc &&
                        formik.errors.testStrctureDesc && (
                          <div
                            className="text-danger mt-1"
                            style={{ fontSize: "0.875em" }}
                          >
                            {formik.errors.testStrctureDesc}
                          </div>
                        )}
                    </FormGroup>
                    <Button
                      color="success"
                      size="sm"
                      onClick={addTestStructure}
                    >
                      + Add Test Structure
                    </Button>

                    <div className="mt-3 vstack gap-3">
                      {formik.values.testStructures.map((ts, index) => {
                        console.log("🚀 ~ TestCreate ~ ts:", ts);
                        return (
                          <Card key={index}>
                            <CardBody>
                              {/* Name */}
                              <FormGroup>
                                <Label>
                                  Name <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  value={ts.name}
                                  onChange={(e) =>
                                    updateTestStructure(
                                      index,
                                      "name",
                                      e.target.value
                                    )
                                  }
                                  invalid={
                                    formik.touched.testStructures?.[index]
                                      ?.name &&
                                    !!formik.errors.testStructures?.[index]
                                      ?.name
                                  }
                                />
                                {formik.touched.testStructures?.[index]?.name &&
                                  formik.errors.testStructures?.[index]
                                    ?.name && (
                                    <FormFeedback>
                                      {formik.errors.testStructures[index].name}
                                    </FormFeedback>
                                  )}
                              </FormGroup>

                              {/* Order Index */}
                              <FormGroup>
                                <Label>
                                  Order Index{" "}
                                  <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  type="number"
                                  value={ts.orderIndex}
                                  onChange={(e) =>
                                    updateTestStructure(
                                      index,
                                      "orderIndex",
                                      parseInt(e.target.value)
                                    )
                                  }
                                  invalid={
                                    formik.touched.testStructures?.[index]
                                      ?.orderIndex &&
                                    !!formik.errors.testStructures?.[index]
                                      ?.orderIndex
                                  }
                                />
                                {formik.touched.testStructures?.[index]
                                  ?.orderIndex &&
                                  formik.errors.testStructures?.[index]
                                    ?.orderIndex && (
                                    <FormFeedback>
                                      {
                                        formik.errors.testStructures[index]
                                          .orderIndex
                                      }
                                    </FormFeedback>
                                  )}
                              </FormGroup>

                              {/* Description */}
                              <FormGroup>
                                <Label>Description</Label>
                                <CKEditor
                                  editor={ClassicEditor}
                                  data={ts.description}
                                  onChange={(event, editor) =>
                                    // updateTestStructure(
                                    //   index,
                                    //   "description",
                                    //   editor.getData()
                                    // )
                                    formik.setFieldValue(
                                      `testStructures.${index}.description`,
                                      editor.getData()
                                    )
                                  }
                                />
                              </FormGroup>

                              {/* Media */}
                              <FormGroup>
                                <Label className="fw-semibold mb-2">
                                  Media
                                </Label>
                                {ts.media ? (
                                  <div className="d-flex align-items-center gap-3 p-3 border rounded bg-light">
                                    <div
                                      style={{
                                        width: 80,
                                        height: 80,
                                        borderRadius: 10,
                                        overflow: "hidden",
                                        border: "1px solid #ddd",
                                      }}
                                    >
                                      <img
                                        src={`${imageBaseApi}${ts.media.url}`}
                                        alt="media"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </div>
                                    <div className="d-flex flex-column justify-content-between">
                                      <div>
                                        <div className="fw-semibold text-break">
                                          {ts.media.fileName || "Media File"}
                                        </div>
                                      </div>
                                      <div className="d-flex gap-2 mt-2">
                                        <Button
                                          size="sm"
                                          color="primary"
                                          outline
                                          onClick={() =>
                                            toggleMediaModal(
                                              "testStructure",
                                              index
                                            )
                                          }
                                        >
                                          Change
                                        </Button>
                                        <Button
                                          size="sm"
                                          color="danger"
                                          outline
                                          onClick={() => {
                                            updateTestStructure(
                                              index,
                                              "mediaId",
                                              ""
                                            );
                                            updateTestStructure(
                                              index,
                                              "media",
                                              null
                                            );
                                          }}
                                        >
                                          Remove
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="text-center p-4 border rounded bg-light">
                                    <i className="ri-image-add-line fs-1 text-secondary"></i>
                                    <h6 className="mt-2 mb-1 text-muted">
                                      No media added
                                    </h6>
                                    <h6 className="mb-3 text-muted">
                                      1200 x 630
                                    </h6>

                                    <Button
                                      outline
                                      size="sm"
                                      color="secondary"
                                      onClick={() =>
                                        toggleMediaModal("testStructure", index)
                                      }
                                    >
                                      Add Media
                                    </Button>
                                  </div>
                                )}
                              </FormGroup>

                              <Button
                                color="danger"
                                size="sm"
                                outline
                                onClick={() => removeTestStructure(index)}
                              >
                                Remove
                              </Button>
                            </CardBody>
                          </Card>
                        );
                      })}
                    </div>
                  </CardBody>
                </Card>
              </TabPane>

              <TabPane tabId="3">
                <Card>
                  <CardBody>
                    <Button
                      color="success"
                      size="sm"
                      onClick={addTestProperties}
                    >
                      + Add Test Properties
                    </Button>

                    <div className="mt-3 vstack gap-3">
                      {formik.values.testProperties.map((ts, index) => {
                        console.log("🚀 ~ TestCreate ~ ts:", ts);
                        return (
                          <Card key={index}>
                            <CardBody>
                              {/* Name */}
                              <FormGroup>
                                <Label>
                                  Name <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  value={ts.name}
                                  onChange={(e) =>
                                    updateTestProperties(
                                      index,
                                      "name",
                                      e.target.value
                                    )
                                  }
                                  invalid={
                                    formik.touched.testProperties?.[index]
                                      ?.name &&
                                    !!formik.errors.testProperties?.[index]
                                      ?.name
                                  }
                                />
                                {formik.touched.testProperties?.[index]?.name &&
                                  formik.errors.testProperties?.[index]
                                    ?.name && (
                                    <FormFeedback>
                                      {formik.errors.testProperties[index].name}
                                    </FormFeedback>
                                  )}
                              </FormGroup>

                              {/* Order Index */}
                              <FormGroup>
                                <Label>
                                  Order Index{" "}
                                  <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  type="number"
                                  value={ts.orderIndex}
                                  onChange={(e) =>
                                    updateTestProperties(
                                      index,
                                      "orderIndex",
                                      parseInt(e.target.value)
                                    )
                                  }
                                  invalid={
                                    formik.touched.testProperties?.[index]
                                      ?.orderIndex &&
                                    !!formik.errors.testProperties?.[index]
                                      ?.orderIndex
                                  }
                                />
                                {formik.touched.testProperties?.[index]
                                  ?.orderIndex &&
                                  formik.errors.testProperties?.[index]
                                    ?.orderIndex && (
                                    <FormFeedback>
                                      {
                                        formik.errors.testProperties[index]
                                          .orderIndex
                                      }
                                    </FormFeedback>
                                  )}
                              </FormGroup>
                              <FormGroup className="d-flex justify-content-between">
                                <Label>Show Before TestStructures?</Label>

                                <Input
                                  type="checkbox"
                                  checked={ts.shouldShowBeforeTestStructures}
                                  onChange={(e) =>
                                    updateTestProperties(
                                      index,
                                      "shouldShowBeforeTestStructures",
                                      e.target.checked // ✅ correct
                                    )
                                  }
                                />
                              </FormGroup>
                              {/* Description */}
                              <FormGroup>
                                <Label>Description</Label>
                                <CKEditor
                                  editor={ClassicEditor}
                                  data={ts.description}
                                  onChange={(event, editor) =>
                                    // updateTestStructure(
                                    //   index,
                                    //   "description",
                                    //   editor.getData()
                                    // )
                                    formik.setFieldValue(
                                      `testProperties.${index}.description`,
                                      editor.getData()
                                    )
                                  }
                                />
                              </FormGroup>

                              {/* Media */}
                              <FormGroup>
                                <Label className="fw-semibold mb-2">
                                  Media
                                </Label>
                                {ts.media ? (
                                  <div className="d-flex align-items-center gap-3 p-3 border rounded bg-light">
                                    <div
                                      style={{
                                        width: 80,
                                        height: 80,
                                        borderRadius: 10,
                                        overflow: "hidden",
                                        border: "1px solid #ddd",
                                      }}
                                    >
                                      <img
                                        src={`${imageBaseApi}${ts.media.url}`}
                                        alt="media"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </div>
                                    <div className="d-flex flex-column justify-content-between">
                                      <div>
                                        <div className="fw-semibold text-break">
                                          {ts.media.fileName || "Media File"}
                                        </div>
                                      </div>
                                      <div className="d-flex gap-2 mt-2">
                                        <Button
                                          size="sm"
                                          color="primary"
                                          outline
                                          onClick={() =>
                                            toggleMediaModal(
                                              "testProperties",
                                              index
                                            )
                                          }
                                        >
                                          Change
                                        </Button>
                                        <Button
                                          size="sm"
                                          color="danger"
                                          outline
                                          onClick={() => {
                                            updateTestProperties(
                                              index,
                                              "mediaId",
                                              ""
                                            );
                                            updateTestProperties(
                                              index,
                                              "media",
                                              null
                                            );
                                          }}
                                        >
                                          Remove
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="text-center p-4 border rounded bg-light">
                                    <i className="ri-image-add-line fs-1 text-secondary"></i>
                                    <h6 className="mt-2 mb-1 text-muted">
                                      No media added
                                    </h6>
                                    <h6 className="mb-3 text-muted">
                                      1200 x 630
                                    </h6>

                                    <Button
                                      outline
                                      size="sm"
                                      color="secondary"
                                      onClick={() =>
                                        toggleMediaModal(
                                          "testProperties",
                                          index
                                        )
                                      }
                                    >
                                      Add Media
                                    </Button>
                                  </div>
                                )}
                              </FormGroup>

                              <Button
                                color="danger"
                                size="sm"
                                outline
                                onClick={() => removeTestProperties(index)}
                              >
                                Remove
                              </Button>
                            </CardBody>
                          </Card>
                        );
                      })}
                    </div>
                  </CardBody>
                </Card>
              </TabPane>
            </TabContent>
          </Col>
          <Col>
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <Label style={{ cursor: "pointer" }}>Banner Media</Label>
                  <Button
                    size="sm"
                    color="success"
                    onClick={() => toggleMediaModal("banner")}
                  >
                    +
                  </Button>
                </div>

                {formik.values.bannerMedia ? (
                  <div className="text-center p-3 border rounded shadow-sm bg-light">
                    <div
                      style={{
                        maxHeight: "220px",
                        overflow: "hidden",
                        borderRadius: "10px",
                        border: "1px solid #ddd",
                      }}
                      className="mb-3"
                    >
                      <img
                        src={`${imageBaseApi}${formik.values.bannerMedia.url}`}
                        alt={
                          formik.values.bannerMedia.fileName || "Banner Image"
                        }
                        style={{ width: "100%", objectFit: "contain" }}
                        className="img-fluid hover-zoom"
                      />
                    </div>

                    <div className="mb-2">
                      <div className="fw-semibold">
                        {formik.values.bannerMedia.name || "Banner Image"}
                      </div>
                      {formik.values.bannerMedia.size && (
                        <small className="text-muted">
                          Size:{" "}
                          {(formik.values.bannerMedia.size / 1024).toFixed(1)}{" "}
                          KB
                        </small>
                      )}
                    </div>

                    <div className="d-flex gap-2 justify-content-center">
                      <Button
                        size="sm"
                        outline
                        color="primary"
                        className="rounded-pill px-3"
                        onClick={() => toggleMediaModal("banner")}
                      >
                        Change
                      </Button>
                      <Button
                        size="sm"
                        outline
                        color="danger"
                        className="rounded-pill px-3"
                        onClick={() => {
                          formik.setFieldValue("bannerMediaId", "");
                          formik.setFieldValue("bannerMedia", null);
                        }}
                      >
                        <i className="ri-delete-bin-5-line me-1"></i> Remove
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="p-4 border rounded text-center bg-light">
                    <i className="ri-image-add-line fs-1 text-secondary"></i>
                    <h6 className="mt-2 mb-3 text-muted">
                      No banner image selected
                    </h6>
                    <h6 className="mb-1 text-muted">1280 x 720</h6>

                    <Button
                      outline
                      color="secondary"
                      className="rounded-pill px-4"
                      onClick={() => toggleMediaModal("banner")}
                    >
                      <i className="ri-image-add-line me-1"></i> Choose Banner
                      Image
                    </Button>
                  </div>
                )}
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <Label style={{ cursor: "pointer" }}>Logo Media</Label>
                  <Button
                    size="sm"
                    color="success"
                    onClick={() => toggleMediaModal("logo")}
                  >
                    +
                  </Button>
                </div>
                {formik.values.logoMedia ? (
                  <div className="text-center p-3 border rounded shadow-sm bg-light">
                    <div
                      style={{
                        maxHeight: "220px",
                        overflow: "hidden",
                        borderRadius: "10px",
                        border: "1px solid #ddd",
                      }}
                      className="mb-3"
                    >
                      <img
                        src={`${imageBaseApi}${formik.values.logoMedia.url}`}
                        alt={formik.values.logoMedia.fileName || "Banner Image"}
                        style={{ width: "100%", objectFit: "contain" }}
                        className="img-fluid hover-zoom"
                      />
                    </div>

                    <div className="mb-2">
                      <div className="fw-semibold text-break">
                        {formik.values.logoMedia.name || "Banner Image"}
                      </div>
                      {formik.values.logoMedia.size && (
                        <small className="text-muted">
                          Size:{" "}
                          {(formik.values.logoMedia.size / 1024).toFixed(1)} KB
                        </small>
                      )}
                    </div>

                    <div className="d-flex gap-2 justify-content-center">
                      <Button
                        size="sm"
                        outline
                        color="primary"
                        className="rounded-pill px-3"
                        onClick={() => toggleMediaModal("logo")}
                      >
                        Change
                      </Button>
                      <Button
                        size="sm"
                        outline
                        color="danger"
                        className="rounded-pill px-3"
                        onClick={() => {
                          formik.setFieldValue("logoMediaId", "");
                          formik.setFieldValue("logoMedia", null);
                        }}
                      >
                        <i className="ri-delete-bin-5-line me-1"></i> Remove
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="p-4 border rounded text-center bg-light">
                    <i className="ri-image-add-line fs-1 text-secondary"></i>
                    <h6 className="mt-2 mb-1 text-muted">
                      No logo image selected
                    </h6>
                    <h6 className="mb-3 text-muted">1200 x 630</h6>

                    <Button
                      outline
                      color="secondary"
                      className="rounded-pill px-4"
                      onClick={() => toggleMediaModal("logo")}
                    >
                      <i className="ri-image-add-line me-1"></i> Choose logo
                      Image
                    </Button>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Media Modal */}
      <MediaModal
        isOpen={mediaModalState.isOpen}
        toggle={toggleMediaModal}
        setSelectedMedia={handleMediaSelect}
        mediaData={mediaData}
      />
    </Container>
  );
};

export default TestCreate;
